// Increment by 100 for each new set of events
// FIXME: update to use a const object instead of a typescript enum
// eslint-disable-next-line @vowkey/platform/no-enums
export enum EventType {
  User_LoggedIn = 1000,
  User_ChangedPassword = 1001,
  User_Updated2fa = 1002,
  User_Disabled2fa = 1003,
  User_Recovered2fa = 1004,
  User_FailedLogIn = 1005,
  User_FailedLogIn2fa = 1006,
  User_ClientExportedVault = 1007,
  User_UpdatedTempPassword = 1008,
  User_MigratedKeyToKeyConnector = 1009,
  User_RequestedDeviceApproval = 1010,
  User_TdeOffboardingPasswordSet = 1011,

  Cipher_Created = 1100,
  Cipher_Updated = 1101,
  Cipher_Deleted = 1102,
  Cipher_AttachmentCreated = 1103,
  Cipher_AttachmentDeleted = 1104,
  Cipher_Shared = 1105,
  Cipher_UpdatedCollections = 1106,
  Cipher_ClientViewed = 1107,
  Cipher_ClientToggledPasswordVisible = 1108,
  Cipher_ClientToggledHiddenFieldVisible = 1109,
  Cipher_ClientToggledCardCodeVisible = 1110,
  Cipher_ClientCopiedPassword = 1111,
  Cipher_ClientCopiedHiddenField = 1112,
  Cipher_ClientCopiedCardCode = 1113,
  Cipher_ClientAutofilled = 1114,
  Cipher_SoftDeleted = 1115,
  Cipher_Restored = 1116,
  Cipher_ClientToggledCardNumberVisible = 1117,
  Cipher_ClientToggledTOTPSeedVisible = 1118,
  Cipher_ClientCopiedBankAccountNumber = 1119,
  Cipher_ClientCopiedBankAccountPin = 1120,
  Cipher_ClientToggledBankAccountNumberVisible = 1121,
  Cipher_ClientToggledBankAccountPinVisible = 1122,
  Cipher_ClientCopiedLicenseNumber = 1123,
  Cipher_ClientToggledLicenseNumberVisible = 1124,
  Cipher_ClientCopiedPassportNumber = 1125,
  Cipher_ClientToggledPassportNumberVisible = 1126,
  Cipher_ClientCopiedSwiftCode = 1127,
  Cipher_ClientToggledSwiftCodeVisible = 1128,
  Cipher_ClientCopiedIban = 1129,
  Cipher_ClientToggledIbanVisible = 1130,
  Cipher_ClientCopiedNationalIdentificationNumber = 1131,
  Cipher_ClientToggledNationalIdentificationNumberVisible = 1132,
  Cipher_ClientHttpAuthReleased = 1133,

  Collection_Created = 1300,
  Collection_Updated = 1301,
  Collection_Deleted = 1302,

  Group_Created = 1400,
  Group_Updated = 1401,
  Group_Deleted = 1402,

  OrganizationUser_Invited = 1500,
  OrganizationUser_Confirmed = 1501,
  OrganizationUser_Updated = 1502,
  OrganizationUser_Removed = 1503,
  OrganizationUser_UpdatedGroups = 1504,
  OrganizationUser_UnlinkedSso = 1505,
  OrganizationUser_ResetPassword_Enroll = 1506,
  OrganizationUser_ResetPassword_Withdraw = 1507,
  OrganizationUser_AdminResetPassword = 1508,
  OrganizationUser_ResetSsoLink = 1509,
  OrganizationUser_FirstSsoLogin = 1510,
  OrganizationUser_Revoked = 1511,
  OrganizationUser_Restored = 1512,
  OrganizationUser_ApprovedAuthRequest = 1513,
  OrganizationUser_RejectedAuthRequest = 1514,
  OrganizationUser_Deleted = 1515,
  OrganizationUser_Left = 1516,
  OrganizationUser_AutomaticallyConfirmed = 1517,
  OrganizationUser_SelfRevoked = 1518,
  OrganizationUser_AdminResetTwoFactor = 1519,
  OrganizationUser_Revoked_TwoFactorNonCompliance = 1520,
  OrganizationUser_Revoked_SingleOrganizationNonCompliance = 1521,
  OrganizationUser_NotificationBannerActionClicked = 1522,
  OrganizationUser_Staged = 1523,
  OrganizationUser_InviteLinkAccepted = 1524,
  OrganizationUser_AdminChangedEmail = 1525,
  OrganizationUser_InviteLinkConfirmed = 1526,

  Organization_Updated = 1600,
  Organization_PurgedVault = 1601,
  Organization_ClientExportedVault = 1602,
  Organization_VaultAccessed = 1603,
  Organization_EnabledSso = 1604,
  Organization_DisabledSso = 1605,
  Organization_EnabledKeyConnector = 1606,
  Organization_DisabledKeyConnector = 1607,
  Organization_SponsorshipsSynced = 1608,
  Organization_CollectionManagementUpdated = 1609,
  Organization_CollectionManagement_LimitCollectionCreationEnabled = 1610,
  Organization_CollectionManagement_LimitCollectionCreationDisabled = 1611,
  Organization_CollectionManagement_LimitCollectionDeletionEnabled = 1612,
  Organization_CollectionManagement_LimitCollectionDeletionDisabled = 1613,
  Organization_CollectionManagement_LimitItemDeletionEnabled = 1614,
  Organization_CollectionManagement_LimitItemDeletionDisabled = 1615,
  Organization_CollectionManagement_AllowAdminAccessToAllCollectionItemsEnabled = 1616,
  Organization_CollectionManagement_AllowAdminAccessToAllCollectionItemsDisabled = 1617,
  Organization_ItemOrganization_Accepted = 1618,
  Organization_ItemOrganization_Declined = 1619,
  Organization_AutoConfirmEnabled_Admin = 1620,
  Organization_AutoConfirmDisabled_Admin = 1621,
  Organization_AutoConfirmEnabled_Portal = 1622,
  Organization_AutoConfirmDisabled_Portal = 1623,
  Organization_InviteLinkCreated = 1624,
  Organization_InviteLinkDomainsEdited = 1625,
  Organization_InviteLinkDeleted = 1626,
  Organization_InviteLinkClientCopied = 1627,
  Organization_InviteLinkRefreshed = 1628,
  Organization_InviteLinkConfirmEnabled = 1629,
  Organization_InviteLinkConfirmDisabled = 1630,

  Policy_Updated = 1700,

  ProviderUser_Invited = 1800,
  ProviderUser_Confirmed = 1801,
  ProviderUser_Updated = 1802,
  ProviderUser_Removed = 1803,

  ProviderOrganization_Created = 1900,
  ProviderOrganization_Added = 1901,
  ProviderOrganization_Removed = 1902,
  ProviderOrganization_VaultAccessed = 1903,

  OrganizationDomain_Added = 2000,
  OrganizationDomain_Removed = 2001,
  OrganizationDomain_Verified = 2002,
  OrganizationDomain_NotVerified = 2003,

  Secret_Retrieved = 2100,
  Secret_Created = 2101,
  Secret_Edited = 2102,
  Secret_Deleted = 2103,
  Secret_Permanently_Deleted = 2104,
  Secret_Restored = 2105,

  Project_Retrieved = 2200,
  Project_Created = 2201,
  Project_Edited = 2202,
  Project_Deleted = 2203,

  ServiceAccount_UserAdded = 2300,
  ServiceAccount_UserRemoved = 2301,
  ServiceAccount_GroupAdded = 2302,
  ServiceAccount_GroupRemoved = 2303,
  ServiceAccount_Created = 2304,
  ServiceAccount_Deleted = 2305,

  PhishingBlocker_SiteAccessed = 2400,
  PhishingBlocker_SiteExited = 2401,
  PhishingBlocker_Bypassed = 2402,

  Send_Created_Text = 2500,
  Send_Created_Text_WithEmailVerification = 2501,
  Send_Created_Text_WithPasswordProtection = 2502,
  Send_Created_File = 2503,
  Send_Created_File_WithEmailVerification = 2504,
  Send_Created_File_WithPasswordProtection = 2505,
  Send_Updated_Text = 2506,
  Send_Updated_File = 2507,
  Send_Deleted_Text = 2508,
  Send_Deleted_File = 2509,
  Send_Accessed_Text = 2510,
  Send_Accessed_File = 2511,
}
